// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"LocationsModal_modalBody__zdQUW","modalFooter":"LocationsModal_modalFooter__2Vgnr"};